import { UI_MODIFICATIONS_MODULE } from '../../../../../../../common/constants/constants';
import type { ExecutionContext } from '../../../../../../../common/types/execution-context';

import type { ExtensionData } from './types';

export const buildExtensionData = (executionContext: ExecutionContext): ExtensionData => {
	const { analyticsViewType: _analyticsViewType, ...executionContextWithoutAnalytics } =
		executionContext;

	return {
		type: UI_MODIFICATIONS_MODULE,
		...executionContextWithoutAnalytics,
	};
};
